<ng-container *ngIf="loaded$ | async">
  <app-edu-element-module-title
    class="title-element"
    [breadcrumbs]="isReloaded && breadcrumbs || null"
    [moduleName]="educationalModule.title"
    [title]="educationalModule.type"
    [totalScore]="iomTotalScore"
    [isStep]="isStep">
  </app-edu-element-module-title>
</ng-container>
<router-outlet></router-outlet>